<template>
  <div id="app">
    <Navbar />
    <router-view />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import twitterLogo from './assets/Twitter_logo_blue_32-cropped.png'


export default {
  name: 'App',
  components: {
    Navbar,
  },
  data (){
    return {
      msg: "hello",
      mounted: false,
      twitter_account_info: {},
      twitter: {},
      tweets: {},

      profile: {
        name: "",
        image: twitterLogo
      },
    }
  },
  created(){
    axios.defaults.headers = {
      "X-CSRFToken": CSRF_TOKEN,
    };
  },
  methods: {
    twitterLogIn: function() {
      // console.log("Twitter log in");
      var me = this.twitter.verifyMe();
      var v = this;
      me.then(
        function(response){
          v.twitter_account_info = response;
          v.profile.image = response.profile_image_url_https;
          v.profile.name = "@" + response.screen_name;
        },
        function(error){
          v.twitter_account_info = {};
          console.warn("error: ", error);
        }
      );
      return me;
    },
    twitterLogOut: function() {
      var p = this.twitter.logOut();
      this.twitter_account_info = {};
      this.profile.name = "";
      this.profile.image = twitterLogo;
      return p;
    }
  },
  mounted: function() {
    this.mounted = true;
    this.twitter = new Twitter();
    this.me = this.twitter.me();
    if (localStorage.getItem('oauth_twitter_token')) {
      this.twitterLogIn();
    }
  }
}
</script>

<style>
body, html, #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

@import'~bootstrap/dist/css/bootstrap.css';
</style>
